import {Component, computed, inject} from '@angular/core';
import {ComparePrintItemComponent} from './compare-print-item/compare-print-item.component';
import {ResultsStore} from '../../../../../shared/store/results.store';

@Component({
  selector: 'app-compare-print-items',
  imports: [
    ComparePrintItemComponent
  ],
  templateUrl: './compare-print-items.component.html',
  styleUrl: './compare-print-items.component.css',
})
export class ComparePrintItemsComponent {
  private resultsStore = inject(ResultsStore);

  compareItems = computed(() => {
    return Object.entries(this.resultsStore.compare_items())
      .map(([key, item]) => ({ key, item }))
      .filter((item) => item.item);
  });
}
